{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Teams",
    "CxiLicenceType_CXI": "CX-Integration",
    "CxiLicenceType_NONE": "Keiner",
    "NAME": "CxiLicenceTypes"
}